import React, { memo } from "react";

import { Skeleton } from "@mui/material";
import { Container } from "react-bootstrap";
import { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react/swiper-react";

import "swiper/swiper.scss";
import "swiper/modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";

import { SlideNextButton, SlidePrevButton } from "../simsCarousel";

import {
  StyledSection,
  StyledTitleH3,
  TestimonialWrapper,
  SideImgWrapper,
  ContentWrapper,
  MainImgWrapper,
  TestimonialSwiper,
} from "./styledTestimonial";
import { SwiperButtonsWrapper } from "../simsCarousel/styledSimsCarousel";

const TestimonialSectionComponent = ({ testimonials, error, isLoaded }) => {
  return (
    <StyledSection className="text-center">
      <Container className="px-2">
        <StyledTitleH3 className="mx-auto mb-3">نظرات کاربران</StyledTitleH3>
        <p>متخصصان و دانش‌آموزان درباره آزتو این‌طور می‌گویند.</p>
        <TestimonialWrapper className="py-3">
          <SideImgWrapper>
            {testimonials.slice(0, 2).map((item, index) => {
              return !isLoaded ? (
                <Skeleton
                  key={index}
                  variant="circular"
                  width={70}
                  height={70}
                  className={`${index % 2 === 0 ? "align-self-end " : ""}img-fluid`}
                />
              ) : (
                <img
                  key={index}
                  src={item.image}
                  alt={item.username}
                  width="70"
                  height="70"
                  className={`${
                    item.id % 2 === 0 ? "align-self-end " : ""
                  }img-fluid`}
                />
              );
            })}
          </SideImgWrapper>
          {error ? (
            <p className="text-center py-5 mb-0">
              خطا در دریافت اطلاعات. لطفا دوباره امتحان کنید.
            </p>
          ) : (
            <TestimonialSwiper
              slidesPerView={1}
              loop={true}
              pagination={{ clickable: true }}
              modules={[Pagination]}
              className="w-100"
            >
              <SwiperButtonsWrapper className="mx-auto" $freeSimsCount={testimonials.length}>
                <SlidePrevButton color="var(--blue-color-light)" />
                <SlideNextButton color="var(--blue-color-light)" />
              </SwiperButtonsWrapper>

              {testimonials.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <ContentWrapper>
                      {!isLoaded ? (
                        <>
                          <MainImgWrapper className="mx-auto">
                            <Skeleton variant="circular" width={96} height={96} />
                          </MainImgWrapper>
                          <Skeleton variant="text" className="mt-4" />
                          <Skeleton variant="text" />
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width={100} className="mx-auto" />
                          <Skeleton variant="text" width={75} className="mx-auto" />
                        </>
                      ) : (
                        <>
                          <MainImgWrapper className="mx-auto">
                            <img
                              src={item.image}
                              alt={item.username}
                              width="96"
                              height="96"
                              className="img-fluid"
                            />
                          </MainImgWrapper>
                          <p className="mt-4">{item.text}</p>
                          <strong>{item.username}</strong>
                          <small className="text-muted">{item.position}</small>
                        </>
                      )}
                    </ContentWrapper>
                  </SwiperSlide>
                );
              })}
            </TestimonialSwiper>
          )}
          <SideImgWrapper>
            {testimonials.slice(2, 4).map((item, index) => {
              return !isLoaded ? (
                <Skeleton
                  key={index}
                  variant="circular"
                  width={70}
                  height={70}
                  className={`${
                    index % 2 === 0 ? "align-self-start " : ""
                  }img-fluid`}
                />
              ) : (
                <img
                  key={index}
                  src={item.image}
                  alt={item.username}
                  width="70"
                  height="70"
                  className={`${
                    item.id % 2 === 0 ? "align-self-start " : ""
                  }img-fluid`}
                />
              );
            })}
          </SideImgWrapper>
        </TestimonialWrapper>
      </Container>
    </StyledSection>
  );
};

export default memo(TestimonialSectionComponent);
